<div style="width: 100vw">
  <table class="scrollable-table">
    <thead>
      <tr>
        <th>Selection Id</th>
        <th>WS Handicap value</th>
        <th>Av. Back Price</th>
        <th>Av. Lay Price</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <b>Missing Handicaps</b>
        </td>
        <td colspan="3">{{ missingHandicaps | json }}</td>
      </tr>
      @for (each of marketUpdate(); track each) {
        <tr>
          <td>{{ runners[each?.id]?.runnerName }}</td>
          <td>{{ each?.ex?.hc }}</td>
          <td><b>ABP</b> {{ each?.ex?.abp | json }}</td>
          <td><b>ALP</b> {{ each?.ex?.alp | json }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
